import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import "./SuccessComponent.css";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { set_image_upload_status } from "../store/image_upload";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FileContext from "../context/Context";
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Webcam from "react-webcam";
import moment from "moment";
import { Typography, Box } from "@mui/material";

const Processing = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [isSubmittingRating, setIsSubmittingRating] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [ratingSucceeded, setRatingSucceded] = useState(false);
  const dispatch = useDispatch();
  const [rating, setRating] = useState(5);
  const navigate = useNavigate();
  const { auditID } = useSelector((state) => state.imagesStore);
  const { image_upload_status } = useSelector(
    (state) => state.imageUploadStore,
  );
  // const [image_upload_status, setimage_upload_status] =
  //   useState(image_upload_status);
  const { capturedInspectionImages, carView, odometerVideo } =
    useContext(FileContext);
  const [qualityCheck, setQualityCheck] = useState(false);
  const [reportGeneration, setReportGeneration] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);

  // Retake Images State and Refs
  const [isRetakePopupOpen, setIsRetakePopupOpen] = useState(true);
  const [retakeImages, setRetakeImages] = useState([]);
  const [uploadingItems, setUploadingItems] = useState({});

  // Camera States
  const [showFullScreenCamera, setShowFullScreenCamera] = useState(false);
  const [currentRetakeItem, setCurrentRetakeItem] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [imageCaptured, setImageCaptured] = useState(false);
  const webcamRef = useRef(null);
  const [suggestion, setSuggestion] = useState("");
  const [perfectImage, setPerfectImage] = useState(false);
  const [isIconVisible, setIsIconVisible] = useState(true);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [progressTimer, setProgressTimer] = useState(6); // Timer for auto-proceed
  const [showTimer, setShowTimer] = useState(false); // Show timer after capture

  const [uploadsComplete, setUploadsComplete] = useState(false);
  const [retakeCompleted, setRetakeCompleted] = useState(false);

  const stencilMap = {
    front_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-front-side.png`,
    front_left_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-front-left-side.png`,
    front_right_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-front-right-side.png`,
    back_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-back-side.png`,
    back_left_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-back-left-side.png`,
    back_right_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-back-right-side.png`,
    left_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-left-side.png`,
    right_side: `${process.env.PUBLIC_URL}/stencil-img-sedan/car-right-side.png`,

    front_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-side.svg`,
    front_left_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-left-side.svg`,
    left_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-left-side.svg`,
    back_left_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-left-side.svg`,
    back_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-side.svg`,
    back_right_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-right-side.svg`,
    right_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-right-side.svg`,
    front_right_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-right-side.svg`,
    outer_windshield: `${process.env.PUBLIC_URL}/inspection-car-other-parts/outer-windshield.svg`,
    inner_windshield: `${process.env.PUBLIC_URL}/inspection-car-other-parts/inner-windshield.svg`,
    front_left_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/front-left-tyre.svg`,
    front_right_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/back-right-tyre.svg`,
    back_right_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/front-right-tyre.svg`,
    back_left_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/back-left-tyre.svg`,
  };

  const check = `${process.env.PUBLIC_URL}/custom-icons/correct.png`;
  const timer = `${process.env.PUBLIC_URL}/custom-icons/timer.png`;
  const star = `${process.env.PUBLIC_URL}/inspection-images/star.png`;
  const step1_pink = `${process.env.PUBLIC_URL}/custom-icons/step1-pink.svg`;
  const step2_grey = `${process.env.PUBLIC_URL}/custom-icons/step2-grey.svg`;
  const step3_grey = `${process.env.PUBLIC_URL}/custom-icons/step3-grey.png`;
  const step2_pink = `${process.env.PUBLIC_URL}/custom-icons/step2-pink.png`;
  const step3_pink = `${process.env.PUBLIC_URL}/custom-icons/step3-pink.png`;
  const success = `${process.env.PUBLIC_URL}/inspection-images/success-background.png`;
  const starEmpty = `${process.env.PUBLIC_URL}/inspection-images/image.png`;
  const starFilled = `${process.env.PUBLIC_URL}/inspection-images/star-filled.png`;
  const cameraIcon = `${process.env.PUBLIC_URL}/custom-icons/camera-icon.png`;
  const reload = `${process.env.PUBLIC_URL}/custom-icons/reload.png`;
  const landscape = `${process.env.PUBLIC_URL}/inspection-icons/landscapeMode.svg`;

  const storedConfig = localStorage.getItem("inspectionConfiguration");
  const inspectionConfig = storedConfig
    ? JSON.parse(storedConfig).inspection_config
    : { selectedItems: [], selectedMode: "photo", selectedCount: 10 };

  const mandatoryImages = [];

  const requiredImages = {
    "Front Side": ["front_side"],
    "Front Left Side": ["front_left_side"],
    "Left Side": ["left_side"],
    "Back Left Side": ["back_left_side"],
    "Back Side": ["back_side"],
    "Back Right Side": ["back_right_side"],
    "Right Side": ["right_side"],
    "Front Right Side": ["front_right_side"],
    Windshield: ["inner_windshield", "outer_windshield"],
    Tyres: [
      "front_left_tyre",
      "front_right_tyre",
      "back_left_tyre",
      "back_right_tyre",
    ],
    Odometer: ["odometer"],
    "Registration number": ["registrationNo"],
    Chassis: ["chassis"],
    RC: ["RC"],
    "Video of RPM": ["video_rpm"],
    "Selfie with the car": ["selfie"],
  };

  const getStencilForPart = (partName) => {
    const key = partName?.toLowerCase().replace(/ /g, "_");
    return stencilMap[key] || null;
  };

  // Analyze lighting function
  const analyzeLighting = (imageData) => {
    const { data, width, height } = imageData;
    let totalBrightness = 0;

    for (let i = 0; i < data.length; i += 4) {
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      const brightness = (r + g + b) / 3;
      totalBrightness += brightness;
    }
    const averageBrightness = totalBrightness / (width * height);

    if (averageBrightness < 100) {
      return "Increase lighting.";
    } else if (averageBrightness > 200) {
      return "Reduce lighting.";
    } else {
      return "Lighting looks good.";
    }
  };

  const captureAndAnalyze = useCallback(() => {
    if (webcamRef?.current && webcamRef.current?.getScreenshot()) {
      const imageSrc = webcamRef.current.getScreenshot();
      const image = new Image();
      image.src = imageSrc;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0, image.width, image.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const lightingSuggestion = analyzeLighting(imageData);
        if (lightingSuggestion === "Lighting looks good.") {
          setPerfectImage(true);
        } else {
          setPerfectImage(false);
        }
        setSuggestion(lightingSuggestion);
      };
    }
  }, []);

  useEffect(() => {
    if (showFullScreenCamera && !imageCaptured) {
      const interval = setInterval(captureAndAnalyze, 500);
      return () => clearInterval(interval);
    }
  }, [captureAndAnalyze, showFullScreenCamera, imageCaptured]);

  // Auto-proceed timer after capture (like camera.js)
  useEffect(() => {
    let timerInterval;
    if (imageCaptured && showTimer && progressTimer > 0) {
      timerInterval = setTimeout(() => {
        setProgressTimer((prev) => prev - 1);
      }, 1000);
    } else if (imageCaptured && showTimer && progressTimer === 0) {
      // Auto upload when timer reaches 0
      handleImageCapture();
      setShowTimer(false);
      setProgressTimer(6);
    }
    return () => clearTimeout(timerInterval);
  }, [imageCaptured, showTimer, progressTimer]);

  // Hide icon after 18 seconds
  useEffect(() => {
    if (showFullScreenCamera && !imageCaptured) {
      setIsIconVisible(true);
      const timer = setTimeout(() => {
        setIsIconVisible(false);
      }, 18000);
      return () => clearTimeout(timer);
    }
  }, [showFullScreenCamera, imageCaptured, currentRetakeItem]);

  // Apply zoom to webcam
  // useEffect(() => {
  // 	const applyZoom = async () => {
  // 		try {
  // 			const stream = webcamRef.current?.video?.srcObject;
  // 			if (stream) {
  // 				const track = stream.getVideoTracks()[0];
  // 				const capabilities = track.getCapabilities();
  // 				if (capabilities.zoom) {
  // 					await track.applyConstraints({
  // 						advanced: [{ zoom: 1.08 }]
  // 					});
  // 					setZoomLevel(1.08);
  // 				}
  // 			}
  // 		} catch (error) {
  // 			console.error('Error applying zoom:', error);
  // 		}
  // 	};

  // 	if (showFullScreenCamera && webcamRef.current) {
  // 		webcamRef.current.video.addEventListener('loadedmetadata', applyZoom);
  // 	}

  // 	return () => {
  // 		if (webcamRef.current) {
  // 			webcamRef.current.video.removeEventListener('loadedmetadata', applyZoom);
  // 		}
  // 	};
  // }, [showFullScreenCamera]);

  const handleCameraClick = (item) => {
    setCurrentRetakeItem(item);
    setShowFullScreenCamera(true);
    setImageCaptured(false);
    setCapturedImage(null);
    setSuggestion("");
    setShowTimer(false);
    setProgressTimer(6);

    toast.info(
      "Make sure the object is clear and visible in the frame and matches the stencil shape",
      {
        position: "bottom-right",
        autoClose: 3000,
        icon: () => (
          <img src={timer} alt="timer" style={{ width: 20, height: 20 }} />
        ),
      },
    );
  };

  const capturePhoto = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot({
        width: 1920,
        height: 1080,
        quality: 1,
      });

      const dataURLtoBlob = (dataURL) => {
        const byteString = atob(dataURL.split(",")[1]);
        const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      };

      const blob = dataURLtoBlob(imageSrc);
      // Debug: log video element resolution and blob size
      try {
        console.log("Retake capture - video size:", {
          videoWidth: webcamRef.current?.video?.videoWidth,
          videoHeight: webcamRef.current?.video?.videoHeight,
        });
      } catch (e) {
        console.warn("Unable to read video element size for retake capture", e);
      }
      console.log("Retake capture - blob size:", blob.size);

      const file = new File([blob], "captured_image.jpeg", {
        type: "image/jpeg",
      });

      setCapturedImage(file);
      setImageCaptured(true);
      setShowTimer(true); // Start timer after capture
      setProgressTimer(6); // Reset timer
    }
  }, [webcamRef]);

  const handleImageCapture = async () => {
    if (!capturedImage || !currentRetakeItem) return;

    const { file_name, key, part } = currentRetakeItem;

    setShowFullScreenCamera(false);
    setUploadingItems((prev) => ({ ...prev, [key]: true }));
    setShowTimer(false);

    toast.info(`Uploading ${part}...`, {
      position: "bottom-right",
      autoClose: false,
      toastId: `uploading-${key}`,
    });

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64String = reader.result.split(",")[1];

      try {
        const response = await axios.post("/process_data/upload-file", {
          blobName: `Insurance_Inspection/auditImages/${file_name}`,
          fileContent: base64String,
          contentType: "image/jpeg",
        });

        if (response.status === 200) {
          console.log(`✅ Retake uploaded for: ${file_name}`);

          const oldData = JSON.parse(localStorage.getItem(key) || "null");

          // Publish retake metadata after the image is stored in S3.
          try {
            await axios.post("/aiProcessingApis/uploadToTopic", {
              id: oldData?.type,
              auditID: auditID,
              image_name: file_name,
              imageCategory: oldData?.name || currentRetakeItem.partKey || part,
              clicked_time: oldData?.clicked_time,
              latitude: oldData?.latitude,
              longitude: oldData?.longitude,
            });
          } catch (topicError) {
            console.error(
              "Error uploading retake metadata to topic:",
              topicError.message,
            );
          }

          await axios
            .post("/create_audit/update_token", {
              audit: auditID,
              retake_status: "YES",
              image_name: file_name,
            })
            .catch((err) => {
              console.error("Database update error:", err);
            });

          localStorage.setItem(
            key,
            JSON.stringify({ ...oldData, result: "Retaken" }),
          );

          toast.dismiss(`uploading-${key}`);

          toast.success(`${part} uploaded successfully!`, {
            position: "bottom-right",
            autoClose: 2000,
          });

          setRetakeImages((prev) => prev.filter((img) => img.key !== key));

          setUploadingItems((prev) => {
            const newState = { ...prev };
            delete newState[key];
            return newState;
          });

          // const updatedList = retakeImages.filter((img) => img.key !== key);
          // if (updatedList.length === 0 && retakeImages.length === 1) {
          //   setTimeout(() => {
          //     handleCloseRetakePopup();
          //   }, 1000);
          // }
        }
      } catch (error) {
        console.error("Upload error:", error);

        toast.dismiss(`uploading-${key}`);
        toast.error(`Failed to upload ${part}. Please try again.`, {
          position: "bottom-right",
          autoClose: 3000,
        });

        setUploadingItems((prev) => {
          const newState = { ...prev };
          delete newState[key];
          return newState;
        });
      }
    };

    reader.readAsDataURL(capturedImage);
  };

  const handleRetakeClick = () => {
    setImageCaptured(false);
    setCapturedImage(null);
    setSuggestion("");
    setShowTimer(false);
    setProgressTimer(6);
  };

  const handleCloseRetakePopup = async () => {
    setIsRetakePopupOpen(false);

    try {
      if (retakeImages.length > 0) {
        console.log("Setting NO for pending retake images:", retakeImages);

        for (const item of retakeImages) {
          await updateAuditTokenBeforeCompletion(auditID, {
            retake_status: "NO",
            image_name: item.file_name,
          });
          console.log(`✅ ${item.file_name} = NO (user skipped)`);
        }
      }
      setRetakeCompleted(true);

      // await updateAuditTokenBeforeCompletion(auditID, {
      //   processed: 1,
      //   status: "x",
      // });

      if (auditID && !emailSent) {
        // console.log("Sending completion email after retake process...");
        await sendCompletionEmail(auditID);
        // console.log("✅ Email sent successfully");
        setEmailSent(true);
      }
    } catch (error) {
      console.error("❌ Error during retake completion flow:", error);
      // toast.error("Audit completion update failed, email was not sent", {
      //   position: "bottom-right",
      //   autoClose: 3000,
      // });
    }

    // setQualityCheck(true);
    // startReportGeneration();
    setQualityCheck(true);
    setReportGeneration(true);
  };

  const closeTab = () => {
    console.log("close");
    navigate("/userType");
  };

  const startReportGeneration = async () => {
    console.log("Starting report generation...");
    // if (!reportGeneration) {
    //   console.log("Starting report generation...");
    //   setReportGeneration(true);

    //   try {
    //     setTimeout(() => {
    //       setReportGenerated(true);
    //       console.log("Report generation completed");
    //     }, 5000);
    //   } catch (error) {
    //     console.error("Error in report generation:", error);
    //     toast.error("Failed to generate report", {
    //       position: "bottom-right",
    //       autoClose: 3000,
    //     });
    //   }
    // }
  };

  const getRetakeImages = (auditID) => {
    const retakeList = [];
    console.log("Checking retake images for audit:", auditID);

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key.startsWith(`stencil_result_${auditID}`)) {
        try {
          const value = JSON.parse(localStorage.getItem(key));
          if (value?.result === "No Match") {
            const partKey = key.split(`${auditID}_`)[1];
            let partName = partKey?.replace(/_/g, " ");

            if (partName) {
              partName = partName
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
            }

            retakeList.push({
              key,
              part: partName || key,
              partKey: partKey,
              file_name: value.file_name,
            });
          }
        } catch (err) {
          console.error("Error parsing localStorage data:", key, err);
        }
      }
    }

    return retakeList;
  };

  useEffect(() => {
    if (!auditID) return;

    console.log("Fetching retake images...");
    const list = getRetakeImages(auditID);
    console.log("Retake images found:", list);
    setRetakeImages(list);

    if (list.length === 0) {
      console.log("No retake images found.");
      setIsRetakePopupOpen(false);
      setRetakeCompleted(true);
    }
  }, [auditID]);

  const updateAuditTokenBeforeCompletion = async (auditId, payload = {}) => {
    try {
      const response = await axios.post("/create_audit/update_token", {
        audit: auditId,
        ...payload,
      });

      console.log("Token update response:", response.data);
      return true;
    } catch (error) {
      console.error(
        "Failed to update audit token before completion email:",
        error,
      );
      throw error;
    }
  };

  const sendCompletionEmail = async (auditId) => {
    // try {
    //   console.log("Sending completion email for audit:", auditId);

    //   const checkResponse = await axios
    //     .post("/rating/check-hyundai-audit", {
    //       auditId: auditId,
    //     })
    //     .catch((err) => {
    //       console.warn(
    //         "Hyundai check failed, proceeding with regular email:",
    //         err,
    //       );
    //       return { data: { isHyundai: false } };
    //     });

    //   const isHyundai = checkResponse?.data?.isHyundai || false;
    //   console.log("Is Hyundai audit?", isHyundai);

    //   const emailPromise = axios.post("/rating/send-upload-complete-email", {
    //     audit_id: auditId,
    //     status: "upload_complete",
    //     message: isHyundai
    //       ? "Audit completed successfully in photo mode (HYUNDAI)"
    //       : "Audit completed successfully in photo mode",
    //   });

    //   const timeoutPromise = new Promise((_, reject) =>
    //     setTimeout(() => reject(new Error("Email timeout")), 30000),
    //   );

    //   const emailResponse = await Promise.race([emailPromise, timeoutPromise]);

    //   if (emailResponse.status === 200 || emailResponse.status === 201) {
    //     console.log("✅ Email notification sent successfully");
    setEmailSent(true);
    //     return true;
    //   }
    // } catch (error) {
    //   console.error("❌ Error sending completion email:", error.message);
    //   toast.warning("Email notification failed, but process continues", {
    //     position: "bottom-right",
    //     autoClose: 3000,
    //   });
    //   return false;
    // }
    console.log("Disabled");
  };

  // useEffect(() => {
  //   if (!image_upload_status) return;
  //   console.log("557",inspectionConfig);

  //   const filteredStatus = Object.keys(image_upload_status).reduce(
  //     (acc, key) => {
  //       if (
  //         mandatoryImages.includes(key) ||
  //         (inspectionConfig &&
  //           inspectionConfig.selectedItems?.some((item) =>
  //             requiredImages[item]?.includes(key),
  //           ))
  //       ) {
  //         acc[key] = image_upload_status[key];
  //       }
  //       return acc;
  //     },
  //     {},
  //   );
  //   console.log("Filtered image upload status for audit images:", filteredStatus);
  //   set_image_upload_status(filteredStatus);
  // }, [image_upload_status, inspectionConfig, mandatoryImages, requiredImages]);

  const getFilteredUploadStatus = () => {
    if (!image_upload_status) return {};

    return Object.keys(image_upload_status).reduce((acc, key) => {
      const isRequired =
        mandatoryImages.includes(key) ||
        inspectionConfig?.selectedItems?.some((item) =>
          requiredImages[item]?.includes(key),
        );

      if (isRequired) {
        acc[key] = image_upload_status[key];
      }

      return acc;
    }, {});
  };
  useEffect(() => {
    if (qualityCheck && reportGenerated && !isPopupOpen && !ratingSucceeded) {
      setTimeout(() => {
        console.log("Opening rating popup...");
        setPopupOpen(true);
      }, 2000);
    }
  }, [qualityCheck, reportGenerated, isPopupOpen, ratingSucceeded]);

  const azure_image_file_name = (audit_id, image_name, file_name) => {
    return `${audit_id}_${image_name}_${file_name}`;
  };

  const handleButtonClick = () => {
    setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const handleStarClick = (star) => {
    setRating(star);
  };

  const handleSubmit = async () => {
    if (rating === 0) return;

    setIsSubmittingRating(true);
    console.log("Rating being sent:", rating);
    try {
      const response = await axios.post("/rating/save-rating", {
        audit: auditID,
        Rating: rating,
      });
      console.log(`Saving rating: ${rating} stars for audit ID: ${auditID}`);
      if (response.status === 200 || response.status === 201) {
        console.log("Rating saved successfully:", response.data);
        setRatingSucceded(true);
        toast.success(`${rating} star rating saved successfully!`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error saving rating:", error);
      toast.error("Failed to save rating. Please try again.", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmittingRating(false);
    }
  };

  const uploadVideoToServer = async (fileName, videoBlob) => {
    try {
      const formData = new FormData();
      formData.append("file", videoBlob, fileName);
      formData.append(
        "blobName",
        `Insurance_Inspection/auditVideos/${fileName}`,
      );

      await axios.post("/process_data/upload_video_to_s3", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Video Upload successful");
    } catch (error) {
      console.error("Error uploading video:", error);
    }
  };
  const axiosInstance = axios.create({
    timeout: 30000,
  });

  const upload_images_data_db = async (
    formData,
    image_name,
    maxRetries = 3,
  ) => {
    let attempt = 0;

    const tryUpload = async () => {
      try {
        const response = await axiosInstance.post(
          "/process_data/upload_process_store_individually",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response.status === 200) {
          const res = {
            image_name: image_name,
            status: 1,
            type: "sql_upload_status",
          };
          dispatch(set_image_upload_status(res));
          console.log("Successful sql upload", response.data);
          return res;
        }
      } catch (error) {
        attempt++;
        if (
          attempt < maxRetries &&
          (error.code === "ECONNABORTED" ||
            (error.response && error.response.status >= 500))
        ) {
          console.log(
            `Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`,
          );
          await new Promise((resolve) =>
            setTimeout(resolve, Math.pow(2, attempt) * 1000),
          );
          return tryUpload();
        } else {
          console.error("Max retries reached or non-retryable error:", error);
          return false;
        }
      }
    };

    return tryUpload();
  };

  const uploadCachedImageToS3 = async (fileName, image_name) => {
    try {
      const cache = await caches.open("image-cache");
      const keys = await cache.keys();

      const imageKey = keys.find(
        (request) =>
          request.url.includes(`${fileName}`) &&
          !request.url.includes(`${fileName}-metadata`),
      );

      if (!imageKey) {
        console.log("No matching cached image found for", fileName);
        return false;
      }

      const cachedResponse = await cache.match(imageKey);

      if (!cachedResponse) {
        console.log(`No cached image found with key: ${fileName}`);
        return false;
      }

      const imageBuffer = await cachedResponse.arrayBuffer();

      const base64String = btoa(
        new Uint8Array(imageBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          "",
        ),
      );

      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/jpeg" });

      const formData = new FormData();
      formData.append(
        "blobName",
        `Insurance_Inspection/auditImages/${fileName}`,
      );
      formData.append("file", blob, fileName);
      formData.append("contentType", "image/jpeg");

      console.log(`Uploading cached image: ${fileName}`);

      const response = await axios.post("/process_data/upload-img", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        timeout: 120000,
      });

      if (response.status === 200) {
        const res = {
          image_name,
          status: 1,
          type: "s3_img_upload_status",
        };

        dispatch(set_image_upload_status(res));

        console.log(`✅ S3 Upload Success: ${fileName}`, response.data);

        return true;
      }

      console.log(`❌ S3 Upload Failed: ${fileName}`, response.status);

      return false;
    } catch (error) {
      console.error("❌ S3 Upload Error");
      console.error("File:", fileName);
      console.error("Status:", error?.response?.status);
      console.error("Response:", error?.response?.data);
      console.error("Message:", error?.message);

      return false;
    }
  };
  const handleRetry = async () => {
    const filteredStatus = getFilteredUploadStatus();

    console.log("Starting retry process...");
    console.log("Filtered upload status:", filteredStatus);

    const retryTasks = [];

    for (const image_name_key in filteredStatus) {
      // const imageStatus = image_upload_status[image_name_key];
      const imageStatus = filteredStatus[image_name_key];

      if (
        imageStatus.s3_img_upload_status === 1 &&
        imageStatus.sql_upload_status === 1
      ) {
        continue;
      }

      const imageDetail = capturedInspectionImages.find(
        (image) => image.name === image_name_key,
      );

      if (!imageDetail) {
        console.warn(`Image details not found for ${image_name_key}`);
        continue;
      }

      const fileName = azure_image_file_name(
        auditID,
        imageDetail.name,
        imageDetail.file.name,
      );

      retryTasks.push(async () => {
        try {
          console.log(`Retrying: ${image_name_key}`);

          const cache = await caches.open("image-cache");
          const keys = await cache.keys();

          const metadataKey = keys.find((request) =>
            request.url.includes(`${fileName}-metadata`),
          );

          if (!metadataKey) {
            console.warn(`Metadata not found for ${image_name_key}`);

            return {
              image: image_name_key,
              success: false,
              reason: "metadata_not_found",
            };
          }

          const metadataResponse = await cache.match(metadataKey);

          if (!metadataResponse) {
            return {
              image: image_name_key,
              success: false,
              reason: "cache_match_failed",
            };
          }

          const cachedData = await metadataResponse.json();

          let s3Result = true;
          let sqlResult = true;

          // Retry S3 upload if needed
          if (imageStatus.s3_img_upload_status === 0) {
            console.log(`Uploading S3: ${image_name_key}`);

            s3Result = await uploadCachedImageToS3(fileName, cachedData.name);

            console.log(`S3 Result for ${image_name_key}:`, s3Result);
          }

          // Retry SQL upload if needed
          if (imageStatus.sql_upload_status === 0) {
            const formData = new FormData();

            formData.append("clickedTime", cachedData.clicked_time);
            formData.append("name", cachedData.name);
            formData.append("id", cachedData.type);
            formData.append("auditID", cachedData.audit_id);
            formData.append("latitude", cachedData.latitude);
            formData.append("longitude", cachedData.longitude);
            formData.append("azure_image_name", fileName);

            sqlResult = await upload_images_data_db(formData, cachedData.name);

            console.log(`SQL Result for ${image_name_key}:`, sqlResult);
          }

          return {
            image: image_name_key,
            success: !!s3Result && !!sqlResult,
            s3Result,
            sqlResult,
          };
        } catch (error) {
          console.error(`Retry failed for ${image_name_key}`, error);

          return {
            image: image_name_key,
            success: false,
            error: error.message,
          };
        }
      });
    }

    // Upload only 3 images at a time
    const batchSize = 3;
    const results = [];

    for (let i = 0; i < retryTasks.length; i += batchSize) {
      const batch = retryTasks.slice(i, i + batchSize);

      console.log(`Processing batch ${Math.floor(i / batchSize) + 1}`);

      const batchResults = await Promise.all(batch.map((task) => task()));

      results.push(...batchResults);
    }

    console.table(results);

    const failedUploads = results.filter((item) => !item.success);

    if (failedUploads.length > 0) {
      console.warn("Failed uploads:", failedUploads);

      return false;
    }

    console.log("All retry uploads successful");

    return true;
  };
  const hasRunRef = useRef(false);
  useEffect(() => {
    const funcCall = async () => {
      console.log("Initial funcCall running...");
      const odometer_video_file_name = `${auditID}_rpm_meter_video.mp4`;
      if (odometerVideo?.length > 0) {
        console.log("Uploading odometer video...");
        await uploadVideoToServer(odometer_video_file_name, odometerVideo[0]);
      }
      console.log("Starting retry process...");
      const retrySuccess = await handleRetry();
      console.log("Retry process completed", retrySuccess);

      if (retrySuccess) {
        setReportGenerated(true);
      }
    };

    if (!hasRunRef.current) {
      funcCall();
      hasRunRef.current = true;
    }
  }, []);

  useEffect(() => {
    if (image_upload_status) {
      // console.log("Rechecking audit images...");
      recheckAuditImages();
    }
  }, [image_upload_status]);

  const recheckAuditImages = async () => {
    const filteredStatus = getFilteredUploadStatus();

    console.log("Rechecking required images only:", filteredStatus);

    if (Object.keys(filteredStatus).length === 0) {
      console.log("No required images found");
      return false;
    }

    const hasPendingUploads = Object.entries(filteredStatus).some(
      ([image_name_key, image]) => {
        const s3Status = Number(image?.s3_img_upload_status ?? 0);
        const sqlStatus = Number(image?.sql_upload_status ?? 0);

        if (s3Status !== 1 || sqlStatus !== 1) {
          console.log("Upload pending for:", image_name_key, "=>", {
            s3Status,
            sqlStatus,
          });
          return true;
        }

        return false;
      },
    );

    if (hasPendingUploads) {
      // console.log("Pending uploads detected. Retrying in 2 seconds...");
      // setTimeout(() => {
      //   console.log("Triggering retry for pending images...");
      //   handleRetry();
      // }, 2000);
      return false;
    }

    console.log("All required images uploaded successfully. Proceeding...");

    setUploadsComplete(true);
    await handleProceed();

    return true;
  };
  const handleProceed = async () => {
    try {
      console.log("handleProceed called for audit:", auditID);

      const uploadedImages = [];

      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (key.startsWith(`stencil_result_${auditID}`)) {
          try {
            const value = JSON.parse(localStorage.getItem(key));

            if (value?.result === "Retaken") {
              uploadedImages.push(value.file_name);
            }
          } catch (err) {
            console.error("Error parsing localStorage:", err);
          }
        }
      }

      for (const image_name of uploadedImages) {
        await axios.post("/create_audit/update_token", {
          audit: auditID,
          retake_status: "YES",
          image_name: image_name,
        });
      }

      // const result2 = await axios.post("/create_audit/update_token", {
      //   audit: auditID,
      //   processed: 1,
      //   status: "processing",
      // });

      // console.log("Database update response:", result2.data);

      setQualityCheck(true);
    } catch (error) {
      console.error("Error in handleProceed:", error);
      setQualityCheck(true);
      toast.error("Database update failed, but continuing process", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };
  useEffect(() => {
    if (uploadsComplete && retakeCompleted) {
      updateAuditStatus();
    }
  }, [uploadsComplete, retakeCompleted]);

  const updateAuditStatus = async () => {
    try {
      await updateAuditTokenBeforeCompletion(auditID, {
        // processed: 1,
        status: "processing",
      });

      console.log("✅ Audit marked as processing");
    } catch (err) {
      console.error(err);
    }
  };
  // useEffect(() => {
  //   console.log("=== STATE UPDATE ===");
  //   console.log("Quality Check:", qualityCheck);
  //   console.log("Report Generation:", reportGeneration);
  //   console.log("Report Generated:", reportGenerated);
  //   console.log("Email Sent:", emailSent);
  //   console.log("Rating Succeeded:", ratingSucceeded);
  //   console.log("====================");
  // }, [
  //   qualityCheck,
  //   reportGeneration,
  //   reportGenerated,
  //   emailSent,
  //   ratingSucceeded,
  // ]);

  const getCurrentStencil = () => {
    if (!currentRetakeItem) return null;
    if (currentRetakeItem.partKey) {
      return getStencilForPart(currentRetakeItem.partKey);
    }
    return getStencilForPart(currentRetakeItem.part);
  };

  const [isInLandscapeMode, setIsInLandscapeMode] = useState(
    window.screen.orientation?.type || "landscape-primary",
  );

  useEffect(() => {
    const updateOrientation = () => {
      setIsInLandscapeMode(
        window.screen.orientation?.type || "landscape-primary",
      );
    };
    window.addEventListener("orientationchange", updateOrientation);
    return () => {
      window.removeEventListener("orientationchange", updateOrientation);
    };
  }, []);

  // Format time for display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <>
      {/* Camera.js Style Camera with Timer */}
      {showFullScreenCamera && (
        <>
          {isInLandscapeMode === "portrait-primary" ||
          isInLandscapeMode === "portrait-secondary" ? (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#000",
                zIndex: 20000,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  height: "9rem",
                  width: "9rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#F2F2F7",
                  borderRadius: "50%",
                }}
              >
                <img
                  src={landscape}
                  alt="Landscape"
                  style={{ height: "4rem" }}
                />
              </div>
              <h3
                style={{
                  marginTop: "1rem",
                  textAlign: "center",
                  color: "white",
                }}
              >
                PLEASE ROTATE YOUR DEVICE
              </h3>
              <h6
                style={{
                  padding: "0 1rem",
                  textAlign: "center",
                  color: "white",
                }}
              >
                Turn on auto-rotation as picture needs to be captured in
                landscape mode.
              </h6>
            </div>
          ) : (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "white",
                zIndex: 20000,
                overflow: "hidden",
              }}
            >
              {/* CURRENT IMAGE TITLE */}
              <Typography
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "8px 8px",
                  gap: "10px",
                  position: "absolute",
                  width: "auto",
                  height: "33px",
                  left: "15px",
                  top: "24px",
                  background: "rgba(255, 255, 255, 0.7)",
                  borderRadius: "8px",
                  fontFamily: "'Montserrat', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "157%",
                  textAlign: "center",
                  letterSpacing: "0.1px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  color: "black",
                  zIndex: 100,
                }}
              >
                Take photo of the {currentRetakeItem?.part}
              </Typography>

              {/* Close button */}
              <button
                onClick={() => {
                  setShowFullScreenCamera(false);
                  setImageCaptured(false);
                  setCapturedImage(null);
                  setShowTimer(false);
                  setProgressTimer(6);
                }}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  zIndex: 100,
                  background: "rgba(0,0,0,0.5)",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ✕
              </button>

              {/* Timer Display - Like camera.js */}
              {/* {showTimer && imageCaptured && (
								<div
									style={{
										position: 'absolute',
										right: '15px',
										top: '100px',
										background: 'rgba(255, 255, 255, 0.6)',
										borderRadius: '8px',
										padding: '8px 8px',
										fontFamily: "'Montserrat', sans-serif",
										fontWeight: 500,
										fontSize: '14px',
										color: 'black',
										zIndex: 100
									}}
								>
									{formatTime(progressTimer)}
								</div>
							)} */}

              {/* IMAGE ICON - Exactly like camera.js */}
              {isIconVisible &&
                !imageCaptured &&
                currentRetakeItem?.partKey && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 101,
                      width: "150px",
                      height: "150px",
                      background: "rgba(255, 255, 255, 0.4)",
                      borderRadius: "50%",
                    }}
                  >
                    <img
                      src={getCurrentStencil()}
                      alt={currentRetakeItem?.part}
                      style={{ width: "80px", height: "80px" }}
                    />
                  </Box>
                )}

              {/* Custom Toast Message */}
              {showTimer && imageCaptured && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 3000,
                  }}
                >
                  <div
                    style={{
                      background: "white",
                      borderRadius: "5px",
                      padding: "1px 1px",
                      marginTop: "5px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "black",
                      minWidth: "260px",
                      backdropFilter: "blur(6px)",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={check}
                      alt="success"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    />

                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        margin: 0,
                        marginBottom: "6px",
                      }}
                    >
                      Photo is correct ?
                    </p>

                    <p
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        opacity: 0.9,
                      }}
                    >
                      Proceeding to next step in
                    </p>

                    <p
                      style={{
                        fontSize: "22px",
                        fontWeight: "500",
                        marginTop: "8px",
                        color: "#FF0083",
                      }}
                    >
                      {progressTimer}s
                    </p>

                    {/* Progress Line */}
                    <div
                      style={{
                        width: "100%",
                        height: "6px",
                        background: "rgba(0,0,0,0.08)",
                        borderRadius: "10px",
                        marginTop: "15px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          background: "#FF0083",
                          width: `${(progressTimer / 6) * 100}%`,
                          transition: "width 1s linear",
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* SUGGESTION FOR LIGHTING */}
              {suggestion && !imageCaptured && (
                <Typography
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "8px 8px",
                    gap: "10px",
                    position: "absolute",
                    width: "auto",
                    height: "33px",
                    left: "15px",
                    bottom: "30px",
                    background: "rgba(255, 255, 255, 0.6)",
                    borderRadius: "8px",
                    fontFamily: "'Montserrat', sans-serif",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "13px",
                    lineHeight: "157%",
                    textAlign: "center",
                    letterSpacing: "0.1px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    color: "black",
                    zIndex: 100,
                  }}
                >
                  {suggestion}
                </Typography>
              )}

              {/* Zoom Level Display */}
              {/* <div
								style={{
									position: 'absolute',
									top: '5px',
									left: '50%',
									transform: 'translateX(-50%)',
									zIndex: 10,
									backgroundColor: 'rgba(0, 0, 0, 0.5)',
									color: 'white',
									padding: '5px 10px',
									borderRadius: '5px',
									height: '20px',
									fontSize: '0.8rem',
									display: 'flex',
									alignItems: 'center'
								}}
							>
								{zoomLevel !== 1 ? `Zoom: ${zoomLevel.toFixed(2)}x` : 'Zoom not detected'}
							</div> */}

              {!imageCaptured ? (
                <>
                  <div
                    className="webcam-container"
                    style={{
                      width: "100vw",
                      height: "100svh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "black",
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <Webcam
                      audio={false}
                      muted={true}
                      mirrored={false}
                      ref={webcamRef}
                      width="100%"
                      height="100%"
                      screenshotFormat="image/jpeg"
                      screenshotQuality={1}
                      videoConstraints={{
                        facingMode: "environment",
                        width: { ideal: 1920 },
                        height: { ideal: 1080 },
                        aspectRatio: 16 / 9,
                      }}
                      className="webcam"
                      style={{
                        position: "absolute",
                        textAlign: "center",
                        zIndex: 8,
                        right: 0,
                        left: 0,
                        top: 0,
                        bottom: 0,
                        objectFit: "contain",
                        backgroundColor: "black",
                      }}
                    />
                  </div>

                  {/* STENCIL OVERLAY */}
                  {currentRetakeItem && getCurrentStencil() && (
                    <img
                      src={getCurrentStencil()}
                      alt="Stencil"
                      style={{
                        position: "absolute",
                        width: "100vw",
                        height: "100svh",
                        objectFit: "cover",
                        zIndex: 9,
                        opacity: 0.35,
                        pointerEvents: "none",
                      }}
                    />
                  )}

                  {/* Capture Button */}
                  <div
                    style={{
                      position: "absolute",
                      right: "1.5rem",
                      height: "100svh",
                      display: "flex",
                      justifyContent: "flex-end",
                      flexDirection: "column",
                      gap: "1rem",
                      top: "44px",
                      zIndex: 2000,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100svh",
                      }}
                    >
                      <button
                        style={{
                          display: "flex",
                          cursor: "pointer",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "72px",
                          height: "72px",
                          backgroundColor: "transparent",
                          borderRadius: "50%",
                          border: perfectImage
                            ? "4px solid #4CAF50"
                            : "4px solid white",
                          padding: "1px",
                        }}
                        onClick={capturePhoto}
                      >
                        <div
                          style={{
                            width: "55px",
                            height: "55px",
                            backgroundColor: "white",
                            borderRadius: "50%",
                          }}
                        ></div>
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {/* Captured Image Preview */}
                  <div
                    style={{
                      width: "100vw",
                      height: "100svh",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "black",
                      zindex: 30,
                    }}
                  >
                    <img
                      src={URL.createObjectURL(capturedImage)}
                      alt="Captured"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  {/* Retake Button */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "1rem",
                      zIndex: 100,
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0.5rem",
                        border: "1.5px solid #FF0083",
                        padding: "0.5rem 1.5rem",
                        backgroundColor: "white",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={handleRetakeClick}
                    >
                      <img
                        src={reload}
                        style={{ width: "1.2rem", height: "1.2rem" }}
                        alt="retake"
                      />
                      <span
                        style={{
                          fontSize: "1rem",
                          fontFamily: "'Montserrat', sans-serif",
                          color: "#FF0083",
                          fontWeight: 500,
                        }}
                      >
                        Retake
                      </span>
                    </button>

                    {/* Auto-progress text */}
                    {/* {showTimer && (
											<div
												style={{
													color: 'white',
													fontSize: '14px',
													backgroundColor: 'rgba(0,0,0,0.6)',
													padding: '5px 15px',
													borderRadius: '20px'
												}}
											>
												Proceeding in {progressTimer} seconds...
											</div>
										)} */}
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}

      <div className="success-container">
        <div className="illustration-section">
          <img src={success} alt="Success Illustration" />
        </div>
        <div className="content-section">
          <div className="check-icon">
            <img src={check} alt="Check Icon" />
          </div>
          {!qualityCheck && (
            <>
              <h2>Processing</h2>
              <p>We are processing the inspection. Keep the window open.</p>
            </>
          )}
          {qualityCheck && !reportGenerated && (
            <>
              <h2>Processing</h2>
              <p>We are processing the inspection. Keep the window open.</p>
            </>
          )}
          {qualityCheck && reportGenerated && ratingSucceeded && (
            <>
              <h2>Processed</h2>
              <p>
                Inspection <strong>{auditID}</strong> is completed! You can
                close the window now
              </p>
            </>
          )}

          <ol className="steps-list">
            <li className="step">
              <span className="step-number-audit">
                <img src={step1_pink} alt="Step 1" />
              </span>
              Quality Check
              {!qualityCheck && (
                <span>
                  <CircularProgress
                    sx={{
                      color: "#ff0088",
                      width: "20px !important",
                      height: "20px !important",
                    }}
                  />
                </span>
              )}
              <span className="vertical-line"></span>
            </li>
            <li className="step">
              <span className="step-number-audit">
                {qualityCheck ? (
                  <img src={step2_pink} alt="Step 2" />
                ) : (
                  <img src={step2_grey} alt="Step 2" />
                )}
              </span>
              Report Generation
              {reportGeneration && !reportGenerated && (
                <span>
                  <CircularProgress
                    sx={{
                      color: "#ff0088",
                      width: "20px !important",
                      height: "20px !important",
                    }}
                  />
                </span>
              )}
              <span className="vertical-line2"></span>
              <ToastContainer />
            </li>
            <li className="step disabled-step">
              <span className="step-number-audit">
                {reportGenerated ? (
                  <img src={step3_grey} alt="Step 3" />
                ) : (
                  <img src={step3_grey} alt="Step 3" />
                )}
              </span>
              Report Submission
            </li>
          </ol>
          {qualityCheck && reportGenerated && !ratingSucceeded && (
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.2rem",
                border: "1.5px solid #FF0083",
                padding: "0rem 1rem",
                backgroundColor: "white",
                borderRadius: "3px",
                opacity: "0.9",
                width: "100%",
                marginTop: "20px",
              }}
              onClick={closeTab}
            >
              <span
                style={{
                  fontSize: "0.9rem",
                  fontFamily: "'Montserrat', sans-serif",
                  color: "#FF0083",
                  padding: "0.5rem",
                  cursor: "pointer",
                }}
              >
                Close
              </span>
            </button>
          )}
        </div>

        <button className="rate-experience-btn" onClick={handleButtonClick}>
          <img src={star} alt="Star Icon" /> RATE EXPERIENCE
        </button>
      </div>

      {isPopupOpen && !ratingSucceeded && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="close-popup" onClick={handleClosePopup}>
              <CloseIcon />
            </div>
            <div className="rating-heading">
              <h4>How was your experience?</h4>
            </div>
            <p>Please share with us your feedback:</p>
            <div className="rating-stars">
              {[1, 2, 3, 4, 5].map((starIndex) => (
                <img
                  key={starIndex}
                  src={starIndex <= rating ? starFilled : starEmpty}
                  alt={`Star ${starIndex}`}
                  className="star-icon"
                  onClick={() => handleStarClick(starIndex)}
                />
              ))}
            </div>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.2rem",
                border:
                  rating != 0 ? "1.5px solid #FF0083" : "1.5px solid #0000003D",
                padding: "0rem 1rem",
                backgroundColor: rating != 0 ? "#FF0083" : "#dcdcdc",
                color: rating != 0 ? "#ffffff" : "#0000003D",
                borderRadius: "3px",
                opacity: "0.9",
                width: "100%",
                marginTop: "0.5rem",
              }}
              disabled={rating != 0 ? false : true}
              onClick={handleSubmit}
            >
              <p
                style={{
                  fontSize: "0.9rem",
                  fontFamily: "'Montserrat', sans-serif",
                  color: rating != 0 ? "#ffffff" : "#0000003D",
                  padding: "0.5rem",
                  cursor: "pointer",
                }}
              >
                {isSubmittingRating ? "Submitting..." : "Submit"}
              </p>
            </button>
          </div>
        </div>
      )}

      {isPopupOpen && ratingSucceeded && (
        <div className="popup-overlay">
          <div className="popup-content-after-rating">
            <div className="close-popup" onClick={handleClosePopup}>
              <CloseIcon />
            </div>
            <div className="rating-heading-completion">
              <h4>Thank you for sharing your feedback</h4>
            </div>
            <p style={{ textAlign: "center" }}>
              Now You Can Close The Browser.
            </p>
          </div>
        </div>
      )}

      {/* Retake Images Modal */}
      {isRetakePopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content-retake">
            <div className="popup-header">
              <h3 className="retake-heading">Retake Images...</h3>
              <button className="close-btn" onClick={handleCloseRetakePopup}>
                ✕
              </button>
            </div>

            <div className="retake-list">
              {retakeImages.length > 0 ? (
                <>
                  <p className="retake-instruction">
                    Please retake the following images:
                  </p>
                  {retakeImages.map((item, idx) => (
                    <div key={idx} className="retake-item">
                      <span>{item.part}</span>
                      {uploadingItems[item.key] ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <CircularProgress
                            size={20}
                            sx={{
                              color: "#ff0088",
                              width: "20px !important",
                              height: "20px !important",
                            }}
                          />
                          <span style={{ fontSize: "12px", color: "#ff0088" }}>
                            Uploading...
                          </span>
                        </div>
                      ) : (
                        <button
                          type="button"
                          className="camera-btn"
                          onClick={() => handleCameraClick(item)}
                        >
                          <img
                            src={cameraIcon}
                            alt="camera"
                            width={22}
                            height={22}
                          />
                        </button>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                <p className="no-retake">No images require retake 🎉</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Processing;
